import React from "react";
import { FaCircleXmark } from "react-icons/fa6";
import { Description, SubTitle } from "../CustomComponents";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/editModal.module.scss";

const ViewSuperVisorDetailModal = ({ handleClose, data }) => {
  return (
    <div>
      <ModalContainer handleClose={handleClose}>
        <div className={cssStyles.modalContainer}>
          <div className="d-flex align-items-center w-100 justify-content-between mb-4">
            <p className="fs-4 fw-medium m-0">Content Detail</p>
            <FaCircleXmark
              onClick={handleClose}
              style={{ cursor: "pointer" }}
            />
          </div>
          <div className="w-100">
            <div className="d-flex align-items-start gap-3">
              <img
                src={data?.image_url}
                className="object-fit-contain image-fluid"
                width={"200px"}
                height={"200px"}
                // style={{
                //   backgroundColor: "black",
                // }}
              />
              <div className="">
                <div className="">
                  <SubTitle text="Name:" classes="fs-5" />
                  <Description
                    text={
                      data?.firstname && data?.lastname
                        ? `${data?.firstname} ${data?.lastname}`
                        : "-"
                    }
                    classes={`fs-7 mb-2 fw-normal ${cssStyles.Detail}`}
                  />
                </div>
                <div className="mt-2">
                  <SubTitle text="User Name:" classes="fs-5" />
                  <Description
                    text={data?.username || "-"}
                    classes={`fs-7 mt-2 fw-normal ${cssStyles.Detail}`}
                  />
                </div>
                <div className="mt-2">
                  <SubTitle text="Email:" classes="fs-5" />
                  <Description
                    text={data?.email || "-"}
                    classes={`fs-7 mt-2 fw-normal ${cssStyles.Detail}`}
                  />
                </div>

                <div className="mt-2">
                  <SubTitle text="Mobile Number:" classes="fs-5" />
                  <Description
                    text={data?.mobile_no || "-"}
                    classes={`fs-7 mt-2 fw-normal ${cssStyles.Detail}`}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </ModalContainer>
    </div>
  );
};

export default ViewSuperVisorDetailModal;
